import { render, staticRenderFns } from "./AiChat.vue?vue&type=template&id=3ef89e4a&scoped=true"
import script from "./AiChat.vue?vue&type=script&lang=js"
export * from "./AiChat.vue?vue&type=script&lang=js"
import style0 from "./AiChat.vue?vue&type=style&index=0&id=3ef89e4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef89e4a",
  null
  
)

export default component.exports